import { ReactNode } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { Typography } from '@/components/typography/typography'
import { cn } from '@/libs/tw'

import { FormValues } from '../../schema'

type FormInputProps = {
	name: keyof FormValues
	label: string
	value: string
	icon?: ReactNode
	hasError?: boolean
	disabled?: boolean
}

export const FormRadioInput = ({
	name,
	label,
	icon,
	value,
	hasError,
	disabled,
}: FormInputProps) => {
	const { setValue } = useFormContext<FormValues>()
	const radioValue = useWatch({ name })

	const onSelect = () => setValue(name, value)

	return (
		<label className={cn('flex w-full cursor-pointer items-center gap-16')}>
			<div className={cn('relative inline-block h-32 w-32')}>
				<input
					onKeyDown={(e) => e.key === 'Enter' && onSelect()}
					type="radio"
					checked={radioValue === value}
					onChange={onSelect}
					disabled={disabled}
					className={cn(
						' h-32 w-32 cursor-pointer appearance-none rounded-[100%] border border-userData-checkBox-secondary md:border-userData-checkBox-primary ',
						hasError && '!border-danger'
					)}
				/>
				{radioValue === value && (
					<div
						className={cn(
							'absolute left-1/2 top-1/2 h-[24px] w-[24px] -translate-x-1/2 -translate-y-1/2 transform rounded-[100%]  bg-userData-checkBox-secondaryMobile md:bg-userData-checkBox-primary '
						)}
					/>
				)}
			</div>
			<div className={cn('flex gap-10', disabled && 'opacity-50')}>
				{icon && icon}
				<Typography style={'p'} element="span" className={cn('select-none')}>
					{label}
				</Typography>
			</div>
		</label>
	)
}
